import type { ComplianceItem } from '../../contentstudio/framework';
import { cn } from '../../lib/cn';

type Props = {
  items?: ComplianceItem[];
};

export function ComplianceChecklist({ items = [] }: Props) {
  const passed = items.filter((i) => i.passed).length;
  const failed = items.length - passed;

  return (
    <div className="space-y-3">
      <div className="flex gap-4 text-sm">
        <span className="text-success-600">Passed: <strong>{passed}</strong></span>
        {failed > 0 && <span className="text-error-600">Failed: <strong>{failed}</strong></span>}
      </div>
      <ul className="space-y-2">
        {items.map((item) => (
          <li
            key={item.label}
            className={cn(
              'rounded-lg border p-3 text-sm',
              item.passed
                ? 'border-success-200 bg-success-50/50 dark:border-success-900 dark:bg-success-950/20'
                : 'border-error-200 bg-error-50/50 dark:border-error-900 dark:bg-error-950/20',
            )}
          >
            <div className="flex items-center gap-2">
              <span className={item.passed ? 'text-success-600' : 'text-error-600'}>
                {item.passed ? '✓' : '✗'}
              </span>
              <span className="font-medium">{item.label}</span>
            </div>
            <p className="mt-1 pl-5 text-xs text-slate-500">{item.detail}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
